import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { func, string, object, node, number } from 'prop-types';
import styled from 'styled-components';
import Circle from './Circle';
import { getLastProfilePhotoUploadDate, hasProfilePhoto } from '../../../core/util/account';
import { isEmptyObject } from '../../../core/util/object';
import { FETCH_USER_PROFILE_PHOTO } from '../../../ducks/userProfilePhotos';

const Root = styled.div`
  display: inline-block;
`;

const RelativeContainer = styled.div`
  position: relative;
  top: 0;
  left: 0;
  height: ${props => props.size}px;
`;

class Avatar extends PureComponent {
  static propTypes = {
    handleAvatarClick: func,
    userProfilePhotos: object,
    fetchProfilePhoto: func,
    profileColor: string,
    userProfile: object,
    clickIcon: node,
    className: string,
    size: number,
  };

  static defaultProps = {
    userProfile: {},
    size: 40,
  };

  getProfilePhoto = () => {
    const { userProfile, userProfilePhotos } = this.props;

    if (!hasProfilePhoto(userProfile)) return null;
    if (!this.savedPhotoIsValid()) {
      this.fetchProfilePhoto();
      return null;
    }

    const { src } = userProfilePhotos[userProfile.user_profile_id];
    return src;
  };

  savedPhotoIsValid = () => {
    const { userProfile, userProfilePhotos } = this.props;
    const photoUploadDate = getLastProfilePhotoUploadDate(userProfile);
    const photoObj = userProfilePhotos[userProfile.user_profile_id];

    return photoObj && photoObj.fetchDate > photoUploadDate;
  };

  fetchProfilePhoto = () => {
    const { userProfilePhotos, fetchProfilePhoto, userProfile } = this.props;
    const photoObj = userProfilePhotos[userProfile.user_profile_id];
    if (photoObj && photoObj.fetching) return;

    fetchProfilePhoto(userProfile);
  };

  render() {
    const { handleAvatarClick, profileColor, userProfile, className, size } = this.props;

    if (isEmptyObject(userProfile)) return null; //TODO use a placeholder
    const src = this.getProfilePhoto() || undefined;

    return (
      <Root>
        <RelativeContainer size={size} className={className}>
          <Circle
            handleClick={handleAvatarClick}
            backgroundColor={src ? undefined : profileColor}
            src={src}
            className={className}
            size={size}
          >
            {userProfile.first_name.slice(0, 1).toUpperCase()}
            {userProfile.last_name.slice(0, 1).toUpperCase()}
          </Circle>
        </RelativeContainer>
      </Root>
    );
  }
}

const mapStateToProps = state => ({
  userProfilePhotos: state.userProfilePhotos,
});

const mapDispatchToProps = dispatch => ({
  fetchProfilePhoto: userProfile => dispatch({ type: FETCH_USER_PROFILE_PHOTO, userProfile }),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Avatar);
